import { render, staticRenderFns } from "./ChemLC241PS9Q2.vue?vue&type=template&id=88bd41b0&scoped=true&"
import script from "./ChemLC241PS9Q2.vue?vue&type=script&lang=js&"
export * from "./ChemLC241PS9Q2.vue?vue&type=script&lang=js&"
import style0 from "./ChemLC241PS9Q2.vue?vue&type=style&index=0&id=88bd41b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bd41b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VForm,VImg})
